export default {
  path: '/',
  component: () => import('./main.component'),
};
